import { useMutation } from '@tanstack/react-query';
import { Button, Field, Input, MachineRaroBrand, Notice, Serif } from '@raro/ui';
import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useParams } from 'react-router';
import ocean from '../assets/ocean.jpg';
import { api } from '../lib/api';

/** /senha → pedir link · /senha/:token → definir nova senha */
export function SenhaPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const request = useMutation({ mutationFn: () => api.post<{ ok: boolean; sent: boolean }>('/auth/password/request', { email }) });
  const reset = useMutation({ mutationFn: () => api.post('/auth/password/reset', { token, password }), onSuccess: () => setTimeout(() => navigate('/login'), 1200) });
  const submit = (e: FormEvent) => { e.preventDefault(); token ? reset.mutate() : request.mutate(); };
  return (
    <div className="rr-auth">
      <section className="rr-auth__hero"><img className="rr-auth__hero-img" src={ocean} alt="" aria-hidden="true" /><MachineRaroBrand size="xl" /><p className="rr-heading">tornar visível<br />o que é visível.</p></section>
      <section className="rr-auth__panel">
        <form className="rr-auth__form rr-form" onSubmit={submit}>
          <div className="rr-stack rr-stack--2"><span className="rr-label">senha</span><h1 className="rr-title">{token ? <>Defina uma <Serif italic>nova</Serif> senha.</> : <>Esqueceu a <Serif italic>senha</Serif>?</>}</h1></div>
          {token ? (
            <Field label="Nova senha" htmlFor="s-pass" hint="mínimo de 8 caracteres"><Input id="s-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} autoFocus /></Field>
          ) : (
            <Field label="E-mail" htmlFor="s-email"><Input id="s-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus /></Field>
          )}
          {request.isSuccess && <Notice>{request.data.sent ? 'se o e-mail existir, o link foi enviado.' : 'sem provedor de e-mail configurado: peça o link a um sócio da Raro.'}</Notice>}
          {reset.isSuccess && <Notice>senha redefinida. entrando…</Notice>}
          {(request.isError || reset.isError) && <Notice tone="error">{((request.error ?? reset.error) as Error).message}</Notice>}
          <div className="rr-form__actions">
            <Button variant="primary" type="submit" disabled={request.isPending || reset.isPending}>{token ? 'salvar senha' : 'pedir link'}</Button>
            <Link className="rr-faint" to="/login" style={{ fontSize: 'var(--rr-text-xs)' }}>voltar ao login</Link>
          </div>
        </form>
      </section>
    </div>
  );
}
